import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'FloorOutput',
  props: {
    input: null,
    type: {
      default: 'long'
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var postFix = computed(function () {
      var _label$props$type;
      var label = {
        long: 'этаж',
        short: 'эт.'
      };
      return (_label$props$type = label[props.type]) !== null && _label$props$type !== void 0 ? _label$props$type : 'эт.';
    });
    return {
      __sfc: true,
      props: props,
      postFix: postFix
    };
  }
});